import React from 'react';
import styled from 'styled-components';
import Modal from 'react-modal';

const customStyles = {
    overlay: {
        zIndex: '999',
        backgroundColor: 'transparent',
        overflowY: 'auto',
        overflowX: 'hidden',
    },
};

Modal.setAppElement('#__next');

const DesktopZoomImage = ({ isZoomed, toggleZoom, zoomImg }) => (
    <ZoomModal
        contentLabel="Coupon Detail Modal"
        isOpen={isZoomed}
        onRequestClose={toggleZoom}
        style={customStyles}
        closeTimeoutMS={500}
        className={isZoomed ? 'zoomOpen' : 'zoomClose'}
    >
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions */}
        <img src={zoomImg} alt="zoom img" onClick={toggleZoom} />
    </ZoomModal>
);
const ZoomModal = styled(Modal)`
    z-index: 9999;
    width: 100vw;
    cursor: url('/zoomCloseCursor.svg'), auto;
    display: block;

    img {
        width: 100vw;
    }

    @media (max-width: 1025px) {
        display: none;
    }
`;
export default DesktopZoomImage;
